import { css } from '@linaria/core';
import { styled } from '@linaria/react';
// intl-next Link не совместим с linaria. Не критично, при необходимости стилизовать дочерений <a> вместо Link
// eslint-disable-next-line no-restricted-imports
import Link from 'next/link';

export const Container = styled.div`
	display: none;

	@media screen and (max-width: 768px) {
		position: fixed;
		left: 16px;
		right: 16px;
		bottom: calc(var(--safe-bottom) + 10px);
		display: flex;
		justify-content: space-around;
		z-index: 2;
		margin: 0 auto;
		padding: 8px 24px;
		max-width: 400px;
		background: var(--color-black-05);
		backdrop-filter: blur(4px);
		border-radius: 40px;
	}
`;

export const TabLink = styled(Link)<{ active: 0 | 1 }>`
	--active: ${({ active = 0 }) => (active ? 'var(--color-error)' : 'inherit')};
	position: relative;
	display: flex;
	justify-content: center;
	align-items: center;
	width: 44px;
	height: 44px;
	color: ${({ active = 0 }) =>
		active ? 'var(--brand-common)' : 'var(--color-white-08)'};
	pointer-events: ${({ active = 0 }) => (active ? 'none' : 'auto')};
`;

export const unreadMessagesClass = css`
	position: absolute;
	top: 0;
	right: 0;
`;
